// @ts-nocheck - This file contains Thymeleaf template variables that TypeScript cannot parse
// Thymeleaf templates for invoice components - EXACTLY matching invoice-template.xhtml

export const invoiceTemplates = {
  // Header section with company logo and name
  invoiceHeader:
    '<header style="width: calc(100% - 20px); height: 100px; margin: 20px; position: relative;">' +
    '<img th:src="${issuerLogo}" alt="Company Logo" style="float: left; height: 100%;" />' +
    '<h3 th:text="${issuerName}" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); margin: 0; width: 30%; text-align: center;">Company Name</h3>' +
    '</header>',

  // Client details section with invoice type and client info
  clientDetails:
    '<div class="client-details" style="width: 100%; overflow: hidden; margin-bottom: 10px;">' +
    '<h1 th:text="${#strings.toUpperCase(invoiceType)}" style="float: left; margin: 0; padding: 0; line-height: 100px;">FACTURE</h1>' +
    '<div style="float: right; min-width: 200px; border: 1px solid black; border-radius: 15px; padding: 0 10px; margin-bottom: 10px;">' +
    '<span th:text="${clientName}" style="display: block; margin: 10px 0; text-align: center;">Client Name</span>' +
    '<span th:text="${clientCity}" style="display: block; margin: 10px 0; text-align: center;">Client City</span>' +
    '<span style="display: block; margin: 10px 0;"><strong>ICE</strong>: <span th:text="${clientIce}">123456789</span></span>' +
    '</div>' +
    '</div>',

  // Invoice resume section with invoice number, date, and client number
  invoiceResume:
    '<div class="invoice-resume" style="display: table; border-collapse: collapse; width: 100%; overflow: hidden; clear: both; margin-bottom: 10px;">' +
    '<div style="float: left; width: 30%; margin-right: 5px; min-width: fit-content;">' +
    '<div style="border: 1px solid black; border-radius: 5px; padding: 5px 10px; min-width: 60px; text-align: center; margin-bottom: 1px;" th:text="${invoiceType + \' N°\'}">FACTURE N°</div>' +
    '<div style="border: 1px solid black; border-radius: 5px; padding: 5px 10px; min-width: 60px; text-align: center; margin-bottom: 1px;" th:text="${invoiceNumber}">INV-001</div>' +
    '</div>' +
    '<div style="float: left; width: 24.25%; margin-right: 5px; min-width: fit-content;">' +
    '<div style="border: 1px solid black; border-radius: 5px; padding: 5px 10px; min-width: 60px; text-align: center; margin-bottom: 1px;">Date</div>' +
    '<div style="border: 1px solid black; border-radius: 5px; padding: 5px 10px; min-width: 60px; text-align: center; margin-bottom: 1px;">' +
    '<div th:text="${creationDate}">31/12/2024</div>' +
    '</div>' +
    '</div>' +
    '<div style="float: left; width: 24.25%; margin-right: 5px; min-width: fit-content;">' +
    '<div style="border: 1px solid black; border-radius: 5px; padding: 5px 10px; min-width: 60px; text-align: center; margin-bottom: 1px;">N° Client</div>' +
    '<div style="border: 1px solid black; border-radius: 5px; padding: 5px 10px; min-width: 60px; text-align: center; margin-bottom: 1px;">' +
    '<div th:text="${clientNumber}">CL001</div>' +
    '</div>' +
    '</div>' +
    '</div>',

  // Products table section - EXACTLY matching the template
  productsTable:
    '<div class="product-page">' +
    '<table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; border: 1px solid black;">' +
    '<thead>' +
    '<tr>' +
    '<th style="border: 1px solid black; padding: 4px; text-align: center;">Code</th>' +
    '<th style="border: 1px solid black; padding: 4px; text-align: center;">DESIGNATION</th>' +
    '<th style="border: 1px solid black; padding: 4px; text-align: center;">Quantité</th>' +
    '<th style="border: 1px solid black; padding: 4px; text-align: center;">U.</th>' +
    '<th style="border: 1px solid black; padding: 4px; text-align: center;">PRIX.HT</th>' +
    '<th style="border: 1px solid black; padding: 4px; text-align: center;">TOTAL.HT</th>' +
    '</tr>' +
    '</thead>' +
    '<tbody>' +
    '<tr th:each="product : ${products}">' +
    '<td style="border-right: 1px solid black; padding: 8px; text-align: left;" th:text="${product.code != null ? product.code : \'\'}">PROD001</td>' +
    '<td style="border-right: 1px solid black; padding: 8px; text-align: left;" th:text="${product.description != null ? product.description : \'\'}">Product Description</td>' +
    '<td style="border-right: 1px solid black; padding: 8px; text-align: left;" th:text="${product.quantity > 0 ? #numbers.formatDecimal(product.quantity, 1, \'WHITESPACE\', 2, \'POINT\') : \'\'}">1.00</td>' +
    '<td style="border-right: 1px solid black; padding: 8px; text-align: left;" th:text="${product.unity != null ? product.unity : \'\'}">PCS</td>' +
    '<td style="border-right: 1px solid black; padding: 8px; text-align: left;" th:text="${product.unitPrice >= 0 && product.quantity > 0 ? #numbers.formatDecimal(product.unitPrice, 1, \'WHITESPACE\', 2, \'POINT\') : \'\'}">100.00</td>' +
    '<td style="border-right: 1px solid black; padding: 8px; text-align: left;" th:text="${product.unitPrice >= 0 && product.quantity > 0 ? #numbers.formatDecimal(product.unitPrice * product.quantity, 1, \'WHITESPACE\', 2, \'POINT\') : \'\'}">100.00</td>' +
    '</tr>' +
    '</tbody>' +
    '</table>' +
    '</div>',

  // Invoice price resume section - EXACTLY matching the template
  invoicePriceResume:
    '<div style="width: 100%; overflow: hidden; margin-bottom: 10px;">' +
    '<div style="float: left; width: 73%; border: 1px solid black; border-radius: 5px; overflow: hidden; margin-right: 5px; height: 70px;">' +
    '<div style="width: 25%; float: left; text-align: center; box-sizing: border-box; border-right: 1px solid black; height: 75px;">' +
    '<span style="display: block; margin: 5px 0; font-size: 12px; font-weight: 500;">Total HT</span>' +
    '<span style="display: block; margin: 5px 0;" th:text="${#numbers.formatDecimal(totalHT, 1, \'WHITESPACE\', 2, \'POINT\')}">1000.00</span>' +
    '</div>' +
    '<div style="width: 25%; float: left; text-align: center; box-sizing: border-box; border-right: 1px solid black; height: 75px;">' +
    '<span style="display: block; margin: 5px 0; font-size: 12px; font-weight: 500;">Remise</span>' +
    '<span class="discount" style="overflow: hidden;">' +
    '<span style="display: block; float: left; width: 49.5%; border-right: 1px solid black;" th:text="${discountRate+ \'%\'}">0%</span>' +
    '<span style="display: block; margin: 5px 0;" th:text="${#numbers.formatDecimal(discount, 1, \'WHITESPACE\', 2, \'POINT\')}">0.00</span>' +
    '</span>' +
    '</div>' +
    '<div style="width: 25%; float: left; text-align: center; box-sizing: border-box; border-right: 1px solid black; height: 75px;">' +
    '<span style="display: block; margin: 5px 0; font-size: 12px; font-weight: 500;">Base imposable</span>' +
    '<span style="display: block; margin: 5px 0;" th:text="${#numbers.formatDecimal(totalHtAfterDiscount, 1, \'WHITESPACE\', 2, \'POINT\')}">1000.00</span>' +
    '</div>' +
    '<div style="width: 24%; float: left; text-align: center; box-sizing: border-box; height: 75px;">' +
    '<span style="display: block; margin: 5px 0; font-size: 12px; font-weight: 500;" th:text="${\'TVA \' + vatRate + \'%\'}">TVA 20%</span>' +
    '<span style="display: block; margin: 5px 0;" th:text="${#numbers.formatDecimal(vatAmount, 1, \'WHITESPACE\', 2, \'POINT\')}">200.00</span>' +
    '</div>' +
    '</div>' +
    '<div style="text-align: center; float: right; width: 25%; border: 1px solid black; border-radius: 5px; overflow: hidden; height: 70px;">' +
    '<div style="width: 100%; border-right: none;">' +
    '<span style="display: block; margin: 5px 0; font-size: 12px; font-weight: 500;">Net A Payer TTC</span>' +
    '<span style="display: block; margin: 5px 0;" th:text="${#numbers.formatDecimal(total, 1, \'WHITESPACE\', 2, \'POINT\')}">1200.00</span>' +
    '</div>' +
    '</div>' +
    '</div>',

  // Amount in words section
  amountInWords:
    '<p>Arrêté la Présente Facture à la somme TTC de:</p>' +
    '<p><strong th:text="${totalInWords}">Mille deux cents dirhams</strong></p>',

  // Footer section - EXACTLY matching the template
  invoiceFooter:
    '<footer id="footer" style="font-size: 10px; padding: 5px; text-align: center;">' +
    '<p><b>R.C:</b> <span th:text="${issuerRc}">RC123456</span> - <b>PATENTE</b> : <span th:text="${issuerTradLicense}">PAT123456</span>  - <b>C.N.S.S:</b> <span th:text="${issuerCnss}">CN123456</span> - <b>I.F:</b> <span th:text="${issuerFi}">FI123456</span> - <b>ICE:</b> <span th:text="${issuerIce}">ICE123456</span></p>' +
    '<hr style="width: 400px; height: 1px; border: none; background-color: #000; margin: 10px auto;"/>' +
    '<p><b>SIÈGE:</b> <span th:text="${issuerAddress}">123 Company Street, City</span> - <b>Tél:</b> <span th:text="${issuerPhone}">+212 5 22 12 34 56</span></p>' +
    '<p><b>E-mail:</b> <span th:text="${issuerEmail}">contact@company.ma</span> - <b>RIB:</b> <span th:text="${issuerRib}">RIB123456789</span></p>' +
    '</footer>',

  // Individual components for flexibility
  companyLogo:
    '<img th:src="${issuerLogo}" alt="Issuer Logo" style="max-width: 100px; height: auto;" />',

  companyName:
    '<h3 th:text="${issuerName}" style="margin: 0; text-align: center;">Company Name</h3>',

  invoiceType:
    '<h1 th:text="${#strings.toUpperCase(invoiceType)}" style="margin: 0; padding: 0; line-height: 100px;">FACTURE</h1>',

  clientInfoBox:
    '<div style="float: right; min-width: 200px; border: 1px solid black; border-radius: 15px; padding: 0 10px; margin-bottom: 10px;">' +
    '<span th:text="${clientName}" style="display: block; margin: 10px 0; text-align: center;">Client Name</span>' +
    '<span th:text="${clientCity}" style="display: block; margin: 10px 0; text-align: center;">Client City</span>' +
    '<span style="display: block; margin: 10px 0;"><strong>ICE</strong>: <span th:text="${clientIce}">123456789</span></span>' +
    '</div>',

  invoiceNumberBox:
    '<div style="float: left; width: 30%; margin-right: 5px; min-width: fit-content;">' +
    '<div style="border: 1px solid black; border-radius: 5px; padding: 5px 10px; min-width: 60px; text-align: center; margin-bottom: 1px;" th:text="${invoiceType + \' N°\'}">FACTURE N°</div>' +
    '<div style="border: 1px solid black; border-radius: 5px; padding: 5px 10px; min-width: 60px; text-align: center; margin-bottom: 1px;" th:text="${invoiceNumber}">INV-001</div>' +
    '</div>',

  dateBox:
    '<div style="float: left; width: 24.25%; margin-right: 5px; min-width: fit-content;">' +
    '<div style="border: 1px solid black; border-radius: 5px; padding: 5px 10px; min-width: 60px; text-align: center; margin-bottom: 1px;">Date</div>' +
    '<div style="border: 1px solid black; border-radius: 5px; padding: 5px 10px; min-width: 60px; text-align: center; margin-bottom: 1px;">' +
    '<div th:text="${creationDate}">31/12/2024</div>' +
    '</div>' +
    '</div>',

  clientNumberBox:
    '<div style="float: left; width: 24.25%; margin-right: 5px; min-width: fit-content;">' +
    '<div style="border: 1px solid black; border-radius: 5px; padding: 5px 10px; min-width: 60px; text-align: center; margin-bottom: 1px;">N° Client</div>' +
    '<div style="border: 1px solid black; border-radius: 5px; padding: 5px 10px; min-width: 60px; text-align: center; margin-bottom: 1px;">' +
    '<div th:text="${clientNumber}">CL001</div>' +
    '</div>' +
    '</div>'
};
